<template>
  <div class="dashboard">
    <div class=""
         qid="pie-charts-container"
         v-if="!hideProcessesStatistics || !hideActivitiesStatistics || !hideSystemsStatistics"
    >
      <div class="">

        <div class="ml-3 mb-3 text-center float-left pie-chart-item card"
             v-show="legalBasisData && legalBasisData.length"
             qid="legal-basis-chart"
        >
          <div class="card-body">
            <h5>{{ $t('analytics.processes.legal_basis_title') }}</h5>
            <div class="mw-250 margin-auto cursor-pointer" @click="handleOpenViewLegalBasisModal">
              <doughnut-chart
                :chartdata="legalBasisChartdata"
                :data="legalBasisData"
                :options="options"
              />
            </div>
          </div>
        </div>
        <div class="ml-3 mb-3 text-center float-left pie-chart-item card"
             v-show="informationObligationData && informationObligationData.length"
             qid="information-obligation-chart"
        >
          <div class="card-body">
            <h5>{{ $t('analytics.processes.information_obligation_title') }}</h5>
            <div class="mw-250 margin-auto cursor-pointer" @click="handleOpenViewInformationObligationModal">
              <doughnut-chart
                :chartdata="informationObligationChartdata"
                :data="informationObligationData"
                :options="options"
              />
            </div>
          </div>
        </div>

        <div class="ml-3 mb-3 text-center float-left pie-chart-item card"
             v-show="retentionRuleData && retentionRuleData.length"
             qid="retention-rule-chart"
        >
          <div class="card-body">
            <h5>{{ $t('analytics.activities.retention_rule_title') }}</h5>
            <div class="mw-250 margin-auto cursor-pointer" @click="handleOpenViewRetentionRuleModal">
              <doughnut-chart
                :chartdata="retentionRuleChartdata"
                :data="retentionRuleData"
                :options="options"
              />
            </div>
          </div>
        </div>
        <div class="ml-3 mb-3 text-center float-left pie-chart-item card"
             v-show="integrityControlData && integrityControlData.length"
             qid="integrity-control-chart"
        >
          <div class="card-body">
            <h5>{{ $t('analytics.activities.integrity_control_title') }}</h5>
            <div class="mw-250 margin-auto cursor-pointer" @click="handleOpenViewIntegrityControlModal">
              <doughnut-chart
                :chartdata="integrityControlChartdata"
                :data="integrityControlData"
                :options="options"
              />
            </div>
          </div>
        </div>
        <div class="ml-3 mb-3 text-center float-left pie-chart-item card"
             v-show="activitySecurityMeasureData && activitySecurityMeasureData.length"
             qid="processing-type-chart"
        >
          <div class="card-body">
            <h5>{{ $t('analytics.activities.measure_title') }}</h5>
            <div class="mw-250 margin-auto cursor-pointer" @click="handleOpenViewActivitySecurityMeasureDataModal">
              <doughnut-chart
                      :chartdata="activitySecurityMeasureChartdata"
                      :data="activitySecurityMeasureData"
                      :options="options"
              />
            </div>
          </div>
        </div>
        <div class="ml-3 mb-3 text-center float-left pie-chart-item card"
             v-show="processingTypeData && processingTypeData.length"
             qid="processing-type-chart"
        >
          <div class="card-body">
            <h5>{{ $t('analytics.activities.processing_type_title') }}</h5>
            <div class="mw-250 margin-auto cursor-pointer" @click="handleOpenViewProcessingTypeModal">
              <doughnut-chart
                :chartdata="processingTypeChartdata"
                :data="processingTypeData"
                :options="options"
              />
            </div>
          </div>
        </div>
        <div class="ml-3 mb-3 text-center float-left pie-chart-item card"
             v-show="systemSecurityMeasureData && systemSecurityMeasureData.length"
             qid="processing-type-chart"
        >
          <div class="card-body">
            <h5>{{ $t('analytics.systems.measure_title') }}</h5>
            <div class="mw-250 margin-auto cursor-pointer" @click="handleOpenViewSystemSecurityMeasureDataModal">
              <doughnut-chart
                      :chartdata="systemSecurityMeasureChartdata"
                      :data="systemSecurityMeasureData"
                      :options="options"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ActivityMeasureValidationsModal
            :showModal="viewActivitySecurityMeasureModal"
            @closeViewModal="handleCloseViewActivitySecurityMeasureModal"
    ></ActivityMeasureValidationsModal>
    <SystemMeasureValidationsModal
            :showModal="viewSystemSecurityMeasureModal"
            @closeViewModal="handleCloseViewSystemSecurityMeasureModal"
    ></SystemMeasureValidationsModal>

    <RetentionRuleValidationsModal
        :showModal="viewRetentionRuleModal"
        @closeViewModal="handleCloseViewRetentionRuleModal"
    ></RetentionRuleValidationsModal>

    <IntegrityControlValidationsModal
        :showModal="viewIntegrityControlModal"
        @closeViewModal="handleCloseViewIntegrityControlModal"
    ></IntegrityControlValidationsModal>

    <ProcessingTypeValidationsModal
        :showModal="viewProcessingTypeModal"
        @closeViewModal="handleCloseViewProcessingTypeModal"
    ></ProcessingTypeValidationsModal>

    <LegalBasisValidationsModal
        :showModal="viewLegalBasisModal"
        @closeViewModal="handleCloseViewLegalBasisModal"
    ></LegalBasisValidationsModal>

    <InformationObligationValidationsModal
        :showModal="viewInformationObligationModal"
        @closeViewModal="handleCloseViewInformationObligationModal"
    ></InformationObligationValidationsModal>

  </div>

</template>

<script>

import piincHttp from '@/util/configureAxios.js'
import DoughnutChart from '@/components/chart/DoughnutChart.vue'
import SystemMeasureValidationsModal from '@/components/analytics/SystemMeasureValidationsModal.vue'
import ActivityMeasureValidationsModal from '@/components/analytics/ActivityMeasureValidationsModal.vue'
import RetentionRuleValidationsModal from '@/components/analytics/RetentionRuleValidationsModal.vue'
import IntegrityControlValidationsModal from '@/components/analytics/IntegrityControlValidationsModal.vue'
import ProcessingTypeValidationsModal from '@/components/analytics/ProcessingTypeValidationsModal.vue'
import InformationObligationValidationsModal from '@/components/analytics/InformationObligationValidationsModal.vue'
import LegalBasisValidationsModal from '@/components/analytics/LegalBasisValidationsModal.vue'
import Avatar from '@/components/Avatar.vue';

export default {
  name: 'MaintenanceDashboard',
  data() {
    return {
      // Activity charts objects
      systemSecurityMeasureChartdata: {
        labels: [this.$t('system.approved'), this.$t('system.rejected'), this.$t('system.unvalidated')],
        datasets: [
          {
            label: 'Technical security measure',
            backgroundColor: ['#23C265', '#F5584A', '#EFF0F5'],
            data: []
          }
        ]
      },
      // Activity charts objects
      retentionRuleChartdata: {
        labels: [this.$t('system.approved'), this.$t('system.rejected'), this.$t('system.unvalidated')],
        datasets: [
          {
            label: 'Retention Rule',
            backgroundColor: ['#23C265', '#F5584A', '#EFF0F5'],
            data: []
          }
        ]
      },
      integrityControlChartdata: {
        labels: [this.$t('system.approved'), this.$t('system.rejected'), this.$t('system.unvalidated')],
        datasets: [
          {
            label: 'Integrity Control',
            backgroundColor: ['#23C265', '#F5584A', '#EFF0F5'],
            data: []
          }
        ]
      },
      activitySecurityMeasureChartdata: {
        labels: [this.$t('system.approved'), this.$t('system.rejected'), this.$t('system.unvalidated')],
        datasets: [
          {
            label: 'Organizational security measure',
            backgroundColor: ['#23C265', '#F5584A', '#EFF0F5'],
            data: []
          }
        ]
      },
      proportionalityChartdata: {
        labels: [this.$t('system.approved'), this.$t('system.rejected'), this.$t('system.unvalidated')],
        datasets: [
          {
            label: 'Proportionality',
            backgroundColor: ['#23C265', '#F5584A', '#EFF0F5'],
            data: []
          }
        ]
      },
      processingTypeChartdata: {
        labels: [this.$t('system.approved'), this.$t('system.rejected'), this.$t('system.unvalidated')],
        datasets: [
          {
            label: 'Processing Type',
            backgroundColor: ['#23C265', '#F5584A', '#EFF0F5'],
            data: []
          }
        ]
      },

      // Process charts objects
      legalBasisChartdata: {
        labels: [this.$t('system.approved'), this.$t('system.rejected'), this.$t('system.unvalidated')],
        datasets: [
          {
            label: 'Legal Basis',
            backgroundColor: ['#23C265', '#F5584A', '#EFF0F5'],
            data: []
          }
        ]
      },
      informationObligationChartdata: {
        labels: [this.$t('system.approved'), this.$t('system.rejected'), this.$t('system.unvalidated')],
        datasets: [
          {
            label: 'Information Obligation',
            backgroundColor: ['#23C265', '#F5584A', '#EFF0F5'],
            data: []
          }
        ]
      },

      // Activity charts data
      retentionRuleData: [],
      integrityControlData: [],
      proportionalityData: [],
      processingTypeData: [],
      systemSecurityMeasureData: [],
      activitySecurityMeasureData: [],
      // Process charts data
      legalBasisData: [],
      informationObligationData: [],

      // Global chart options
      options: {
        responsive: true,
        maintainAspectRatio: false
      },

      viewRetentionRuleModal: false,
      viewIntegrityControlModal: false,
      viewProportionalityModal: false,
      viewProcessingTypeModal: false,
      viewSystemSecurityMeasureModal: false,
      viewActivitySecurityMeasureModal: false,

      viewLegalBasisModal: false,
      viewInformationObligationModal: false,

      hideProcessesStatistics: false,
      hideActivitiesStatistics: false,
      hideSystemsStatistics: false
    };
  },
  components: {
    DoughnutChart,
    SystemMeasureValidationsModal,
    ActivityMeasureValidationsModal,
    RetentionRuleValidationsModal,
    IntegrityControlValidationsModal,
    ProcessingTypeValidationsModal,
    InformationObligationValidationsModal,
    LegalBasisValidationsModal,
    Avatar
  },
  computed: {
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function () {
      this.loadSystemsStatistics()
      this.loadActivitiesStatistics()
      this.loadProcessesStatistics()
    }
  },
  methods: {
    handleOpenViewActivitySecurityMeasureDataModal() {
      this.viewActivitySecurityMeasureModal = true;
    },
    handleCloseViewActivitySecurityMeasureModal() {
      this.viewActivitySecurityMeasureModal = false;
    },
    handleOpenViewSystemSecurityMeasureDataModal() {
      this.viewSystemSecurityMeasureModal = true;
    },
    handleCloseViewSystemSecurityMeasureModal() {
      this.viewSystemSecurityMeasureModal = false;
    },
    handleOpenViewRetentionRuleModal() {
      this.viewRetentionRuleModal = true;
    },
    handleCloseViewRetentionRuleModal() {
      this.viewRetentionRuleModal = false;
    },
    handleOpenViewIntegrityControlModal() {
      this.viewIntegrityControlModal = true;
    },
    handleCloseViewIntegrityControlModal() {
      this.viewIntegrityControlModal = false;
    },
    handleOpenViewProcessingTypeModal() {
      this.viewProcessingTypeModal = true;
    },
    handleCloseViewProcessingTypeModal() {
      this.viewProcessingTypeModal = false;
    },
    handleOpenViewLegalBasisModal() {
      this.viewLegalBasisModal = true;
    },
    handleCloseViewLegalBasisModal() {
      this.viewLegalBasisModal = false;
    },
    handleOpenViewInformationObligationModal() {
      this.viewInformationObligationModal = true;
    },
    handleCloseViewInformationObligationModal() {
      this.viewInformationObligationModal = false;
    },
    loadSystemsStatistics() {
      let self = this;
      self.hideSystemsStatistics = false;
      piincHttp.get('systems/statistics', { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data && !response.data.measure) {
          self.hideSystemsStatistics = true
        }
        _.forEach(response.data.measure, function (value) {
          self.systemSecurityMeasureData.push(value);
        })
      }, function() {});
    },
    loadActivitiesStatistics() {
      let self = this;
      self.retentionRuleData = []
      self.integrityControlData = []
      self.proportionalityData = []
      self.processingTypeData = []
      self.activitySecurityMeasureData = []
      self.hideActivitiesStatistics = false;
      piincHttp.get('activities/statistics', { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data && !response.data.retention_rule && !response.data.integrity_control && !response.data.proportionality && !response.data.processing_type) {
          self.hideActivitiesStatistics = true
        }
        _.forEach(response.data.retention_rule, function (value) {
          self.retentionRuleData.push(value);
        })
        _.forEach(response.data.integrity_control, function (value) {
          self.integrityControlData.push(value);
        })
        _.forEach(response.data.measure, function (value) {
          self.activitySecurityMeasureData.push(value);
        })
        _.forEach(response.data.proportionality, function (value) {
          self.proportionalityData.push(value);
        })
        _.forEach(response.data.processing_type, function (value) {
          self.processingTypeData.push(value);
        })
      }, function() {});
    },
    loadProcessesStatistics() {
      let self = this;
      self.legalBasisData = []
      self.informationObligationData = []
      self.hideProcessesStatistics = false;
      piincHttp.get('processes/statistics', { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data && !response.data.legal_basis && !response.data.information_obligation) {
          self.hideProcessesStatistics = true
        }
        _.forEach(response.data.legal_basis, function (value) {
          self.legalBasisData.push(value);
        })
        _.forEach(response.data.information_obligation, function (value) {
          self.informationObligationData.push(value);
        })
      }, function() {});
    }
  },
  created () {
    if (this.getClient && this.getClient.slug) {
      this.loadSystemsStatistics()
      this.loadActivitiesStatistics()
      this.loadProcessesStatistics()
    }
  }
}
</script>
